import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GradienButton, PrimaryButton } from "../../../../Constant";
import { GRADIEN_BUTTONS, GRADIEN_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const GradienButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={GradienButton} span={GRADIEN_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn color="primary-gradien" id="Tooltip-75">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-75" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-primary-gradien</ToolTip>
          {GRADIEN_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} />
          ))}
        </CardBody>
      </Card>
    );
};

export default GradienButtons;
